export interface ListingsType {
  url: string;
  name: string;
}

const listingCategories: Array<ListingsType> = [
  { url: "all", name: "All Listings" },
  { url: "collabs", name: "Contributors/Collaborators Wanted" },
  { url: "cfp", name: "Conference CFP" },
  { url: "forhire", name: "Available for Hire" },
  { url: "education", name: "Education/Courses" },
  { url: "jobs", name: "Job Listings" },
  { url: "mentors", name: "Offering Mentorship" },
  { url: "mentees", name: "Seeking a Mentor" },
  { url: "forsale", name: "Stuff for Sale" },
  { url: "events", name: "Upcoming Events" },
  { url: "misc", name: "Miscellaneous" },
  { url: "products", name: "Products/Tools" },
];

export default listingCategories;
